import * as Yup from "yup";
import i18n from "../i18n";

export const SearchBlacklistVisitorsCardSchema = Yup.object({
  blacklistType: Yup.string().required(
    i18n.language === "en"
      ? "Blacklist type is required"
      : "نوع القائمة السوداء مطلوب"
  ),

  eid: Yup.string(),
  passportNumber: Yup.string().matches(
    /^(?!^0+$)[a-zA-Z0-9]{3,20}$/,
    i18n.language === "en"
      ? "Enter valid passport number"
      : "أدخل رقم جواز سفر صالحاً."
  ),
  iqama: Yup.string().matches(
    /^$|\d{1,10}$/,
    i18n.language === "en"
      ? "Enter a valid iqama number."
      : "أدخل رقم إقامة صالح."
  ),
  visaNumber: Yup.string().matches(
    /^[A-Z0-9][A-Z0-9\s-]{5,13}$/,
    i18n.language === "en"
      ? "Enter a valid visa number"
      : "أدخل رقم تأشيرة صالحًا"
  ),
  companyName: Yup.string().required(
    i18n.language === "en" ? "Company name is required." : "اسم الشركة مطلوب."
  ),

  nationality: Yup.string().required(
    i18n.language === "en" ? "Nationality is required." : "الجنسية مطلوبة."
  ),

  reason: Yup.string().required(
    i18n.language === "en" ? "Reason is required." : "السبب مطلوب"
  ),
});
